export const ignoredHttpErrorCodes = [401, 403];

export const httpErrorCodeToMessage = {
  401: '401 - Unauthorized',
  403: "You don't have permission to perform this operation",
};
